import React from 'react';
import ActivityLoader from '../../components/Common/ActivityLoader';

const BestPlanCard = ({ bestPlan, money, formatCount, loading, noData, styles }) => {
  return (
    <div className="card custom-card mb-4" style={styles.softCard}>
      <div className="card-body">
        <h6 className="card-title mb-2">Best Performing Plan</h6>

        {loading && <ActivityLoader />}
        {noData && <div className="text-muted">No plan data available.</div>}

        {!loading && !noData && bestPlan && (
          <div className="mt-2">
            <div className="d-flex align-items-center justify-content-between">
              <h5 className="mb-0">{bestPlan.plan_name}</h5>
              <span className="badge badge-success">Top</span>
            </div>

            <div className="mt-3 d-grid gap-2">
              <div className="d-flex justify-content-between text-muted">
                <span>Vouchers sold</span>
                <span className="text-body font-weight-semibold">
                  {formatCount(bestPlan.vouchers_sold)}
                </span>
              </div>
              <div className="d-flex justify-content-between text-muted">
                <span>Amount sold</span>
                <span className="text-body font-weight-semibold">
                  {money(bestPlan.amount_sold)}
                </span>
              </div>
              <div className="d-flex justify-content-between text-muted">
                <span>Avg price</span>
                <span className="text-body font-weight-semibold">
                  {money(bestPlan.avg_price)}
                </span>
              </div>

              <hr style={{ borderColor: 'rgba(255,255,255,0.5)' }} />

              <div className="text-muted small">
                First used:{' '}
                <span className="text-body">
                  {bestPlan.first_used_at || '—'}
                </span>
              </div>
              <div className="text-muted small">
                Last used:{' '}
                <span className="text-body">
                  {bestPlan.last_used_at || '—'}
                </span>
              </div>
            </div>
          </div>
        )}

        {!loading && !noData && !bestPlan && (
          <div className="text-muted">No plan picked yet.</div>
        )}
      </div>
    </div>
  );
};

export default BestPlanCard;
